import React, { useEffect } from 'react';
import { useLocation } from '@reach/router';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import { useIntl } from 'gatsby-plugin-intl';
import useStickyState from 'hooks/useStickyState';
import withLocale from 'hoc/withLocale';

import {
  StyledBar,
  StyledTextWrapper,
  StyledLink,
  StyledText,
  StyledAccept,
} from './CookieBarStyles';

const CookieBar = ({ currentLocale }) => {
  const intl = useIntl();
  const location = useLocation();
  useEffect(() => {
    initializeAndTrack(location.hostname);
  }, []);

  const [bannerHidden, setBannerHidden] = useStickyState(
    false,
    'consentCookieHidden'
  );

  const handleAcceptCookies = () => {
    document.cookie = 'gatsby-gdpr-google-tagmanager=true';
    setBannerHidden(true);
  };

  return (
    <>
      {!bannerHidden && (
        <StyledBar>
          <StyledTextWrapper>
            <StyledText>
              {intl.formatMessage({ id: 'private_policy.text' })}{' '}
              <StyledLink
                to={`/${currentLocale}/${intl.formatMessage({
                  id: 'private_policy.link.url',
                })}`}
              >
                {intl.formatMessage({ id: 'private_policy.link.label' })}
              </StyledLink>
              .
            </StyledText>
            <StyledAccept onClick={handleAcceptCookies}>OK</StyledAccept>
          </StyledTextWrapper>
        </StyledBar>
      )}
    </>
  );
};

export default withLocale(CookieBar);
